import React from "react";
import AnimalNameForm from "./AnimalForm";
import { useNavigate } from "react-router";
import HorseHead from "./icons/HorseHead";

export default function StartPage() {
    const navigate = useNavigate();

    const setName = (name) => {
        navigate('/questions', { state: { name } });
    };

    return (
        <>
            <HorseHead />
            <h1>Get a Personalized SmartPaks Plan in Minutes</h1>
            <AnimalNameForm onSubmit={setName} />
        </>
    );
}
